// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// InteractionType — source: shared/config/interaction_types.config.json

export const INTERACTION_TYPE_VALUES = ["note", "email", "call", "meeting", "task", "custom", "email_sent", "email_received", "email_opened", "email_clicked", "call_logged", "meeting_scheduled", "meeting_completed", "note_created", "task_created", "task_completed", "stage_changed", "owner_changed", "field_changed", "record_created", "sequence_enrolled", "sequence_completed", "sequence_reply", "outreach_email_sent", "outreach_email_opened", "outreach_email_clicked", "outreach_call_completed", "outreach_task_completed", "prospect_researched", "prospect_converted", "lead_status_auto_advanced", "whatsapp_sent", "whatsapp_received"] as const;
export type InteractionType = (typeof INTERACTION_TYPE_VALUES)[number];

export const interactionTypeColor: Record<InteractionType, string> = {
  "note": "bg-muted text-muted-foreground",
  "email": "bg-info/10 text-info",
  "call": "bg-success/10 text-success",
  "meeting": "bg-primary/10 text-primary",
  "task": "bg-warning/10 text-warning",
  "custom": "bg-accent text-accent-foreground",
  "email_sent": "bg-info/10 text-info",
  "email_received": "bg-info/10 text-info",
  "email_opened": "bg-info/10 text-info",
  "email_clicked": "bg-info/10 text-info",
  "call_logged": "bg-success/10 text-success",
  "meeting_scheduled": "bg-primary/10 text-primary",
  "meeting_completed": "bg-primary/10 text-primary",
  "note_created": "bg-muted text-muted-foreground",
  "task_created": "bg-warning/10 text-warning",
  "task_completed": "bg-success/10 text-success",
  "stage_changed": "bg-primary/10 text-primary",
  "owner_changed": "bg-muted text-muted-foreground",
  "field_changed": "bg-muted text-muted-foreground",
  "record_created": "bg-success/10 text-success",
  "sequence_enrolled": "bg-muted text-muted-foreground",
  "sequence_completed": "bg-muted text-muted-foreground",
  "sequence_reply": "bg-muted text-muted-foreground",
  "outreach_email_sent": "bg-muted text-muted-foreground",
  "outreach_email_opened": "bg-muted text-muted-foreground",
  "outreach_email_clicked": "bg-muted text-muted-foreground",
  "outreach_call_completed": "bg-muted text-muted-foreground",
  "outreach_task_completed": "bg-muted text-muted-foreground",
  "prospect_researched": "bg-muted text-muted-foreground",
  "prospect_converted": "bg-muted text-muted-foreground",
  "lead_status_auto_advanced": "bg-muted text-muted-foreground",
  "whatsapp_sent": "bg-success/10 text-success",
  "whatsapp_received": "bg-success/10 text-success",
};

export const interactionTypeIcon: Record<InteractionType, string> = {
  "note": "StickyNote",
  "email": "Mail",
  "call": "Phone",
  "meeting": "Calendar",
  "task": "CheckSquare",
  "custom": "Tag",
  "email_sent": "Send",
  "email_received": "Inbox",
  "email_opened": "Mail",
  "email_clicked": "Mail",
  "call_logged": "Phone",
  "meeting_scheduled": "Calendar",
  "meeting_completed": "Calendar",
  "note_created": "StickyNote",
  "task_created": "CheckSquare",
  "task_completed": "CheckSquare",
  "stage_changed": "Handshake",
  "owner_changed": "User",
  "field_changed": "Edit",
  "record_created": "Plus",
  "sequence_enrolled": "StickyNote",
  "sequence_completed": "StickyNote",
  "sequence_reply": "StickyNote",
  "outreach_email_sent": "StickyNote",
  "outreach_email_opened": "StickyNote",
  "outreach_email_clicked": "StickyNote",
  "outreach_call_completed": "StickyNote",
  "outreach_task_completed": "StickyNote",
  "prospect_researched": "StickyNote",
  "prospect_converted": "StickyNote",
  "lead_status_auto_advanced": "StickyNote",
  "whatsapp_sent": "WhatsApp",
  "whatsapp_received": "WhatsApp",
};

export const interactionTypeManualLoggable: Record<InteractionType, true | false> = {
  "note": true,
  "email": true,
  "call": true,
  "meeting": true,
  "task": true,
  "custom": true,
  "email_sent": false,
  "email_received": false,
  "email_opened": false,
  "email_clicked": false,
  "call_logged": false,
  "meeting_scheduled": false,
  "meeting_completed": false,
  "note_created": false,
  "task_created": false,
  "task_completed": false,
  "stage_changed": false,
  "owner_changed": false,
  "field_changed": false,
  "record_created": false,
  "sequence_enrolled": false,
  "sequence_completed": false,
  "sequence_reply": false,
  "outreach_email_sent": false,
  "outreach_email_opened": false,
  "outreach_email_clicked": false,
  "outreach_call_completed": false,
  "outreach_task_completed": false,
  "prospect_researched": false,
  "prospect_converted": false,
  "lead_status_auto_advanced": false,
  "whatsapp_sent": false,
  "whatsapp_received": false,
};

export const interactionTypeCountsAsOutreach: Record<InteractionType, false | true> = {
  "note": false,
  "email": true,
  "call": true,
  "meeting": true,
  "task": false,
  "custom": false,
  "email_sent": true,
  "email_received": false,
  "email_opened": false,
  "email_clicked": false,
  "call_logged": true,
  "meeting_scheduled": true,
  "meeting_completed": true,
  "note_created": false,
  "task_created": false,
  "task_completed": false,
  "stage_changed": false,
  "owner_changed": false,
  "field_changed": false,
  "record_created": false,
  "sequence_enrolled": false,
  "sequence_completed": false,
  "sequence_reply": false,
  "outreach_email_sent": true,
  "outreach_email_opened": false,
  "outreach_email_clicked": false,
  "outreach_call_completed": true,
  "outreach_task_completed": true,
  "prospect_researched": false,
  "prospect_converted": false,
  "lead_status_auto_advanced": false,
  "whatsapp_sent": true,
  "whatsapp_received": false,
};

